import { Chip } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { isTemporarilyInactive } from "./format";

// Inactive wins over temporarily inactive: a temporary inactivation of an
// inactive customer changes nothing about what it receives.
export default function StateBadge({
  active,
  tempInactiveTs,
}: {
  active: boolean | undefined;
  tempInactiveTs?: string | null;
}) {
  if (active === false) {
    return (
      <Chip
        size="small"
        color="default"
        label={<FormattedMessage defaultMessage="Inactive" />}
      />
    );
  }
  if (isTemporarilyInactive(tempInactiveTs)) {
    return (
      <Chip
        size="small"
        color="warning"
        label={<FormattedMessage defaultMessage="Temp. inactive" />}
      />
    );
  }
  return null;
}
